import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom'

import Chat from './chat/Chat';

/**
 * Wrapper class for the whole webclient.
 * To run with https: ($env:HTTPS = "true") -and (npm start)
 */
class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <Switch>
          <Route exact path={'/spectate/:token/:userId/:languageData/:chatAgentMode?/:integrationType?'} component={Chat}/>
          <Route path={'/clientKey/:clientKey/token/:token?'} component={Chat} />
        </Switch>
      </BrowserRouter>
    );
  }
}

export default App;
